<script setup lang="ts">
const { t } = useI18n()

const open = defineModel<boolean>('open', { default: false })

const props = withDefaults(
  defineProps<{
    item?: string
    count?: number
    secondaryActionPromise?: () => boolean | Promise<boolean>
  }>(),
  {
    item: '',
    count: 0,
  },
)

const isBulk = computed(() => props.count > 0)

const closeModal = () => {
  open.value = false
  return true
}

const handleDelete = async () => {
  open.value = false
  await props.secondaryActionPromise?.()
  return true
}

const openModal = () => {
  open.value = true
}
</script>

<template>
  <div>
    <OModal
      v-model:open="open"
      :secondary-action-title="t('cancel')"
      :primary-action-title="t('delete')"
      primary-action-enabled
      secondary-action-enabled
      :secondary-action-promise="closeModal"
      :primary-action-promise="handleDelete"
      danger
      :title="isBulk ? t('confirm_deletion') : t('delete_configuration')"
    >
      <template #content>
        <i18n-t
          v-if="isBulk"
          keypath="bulk_delete_configurations_confirmation"
          tag="span"
          class="typography-body-2 text-neutral-1"
        >
          <template #selection>
            <span class="typography-body-2-strong">
              {{ t('selected_virtual_agents_count', { count: props.count }) }}
            </span>
          </template>
        </i18n-t>
        <i18n-t
          v-else
          keypath="delete_configuration_subtitle"
          tag="span"
          class="typography-body-2 text-neutral-1"
        >
          <template #name>
            <span class="typography-body-2-strong">
              {{ props.item }}
            </span>
          </template>
        </i18n-t>
      </template>
    </OModal>

    <slot :handle-click="openModal" />
  </div>
</template>
